import React from 'react';

export function JdsSkeleton({ width = '100%', height = 16, style, className = '' }) {
  return (
    <span
      className={`jds-skeleton ${className}`}
      style={{ width, height, ...style }}
      aria-hidden="true"
    />
  );
}

// Placeholder de tabela (progressComponent do react-data-table-component).
export function JdsTableSkeleton({ rows = 8, columns = 5 }) {
  return (
    <div
      role="status"
      aria-label="Carregando"
      style={{ width: '100%', padding: '8px 16px' }}
    >
      {Array.from({ length: rows }, (_, row) => (
        <div
          key={row}
          style={{ display: 'flex', gap: 24, alignItems: 'center', height: 52 }}
        >
          {Array.from({ length: columns }, (_, col) => (
            <JdsSkeleton
              key={col}
              height={14}
              style={{ flex: col === 2 ? 2 : 1 }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

// Placeholder de tela de detalhes: breadcrumb + card com linhas label/valor.
export function JdsDetailSkeleton({ rows = 7 }) {
  return (
    <div className="jds-scope" role="status" aria-label="Carregando">
      <JdsSkeleton width={220} height={14} style={{ marginBottom: 20 }} />
      <div className="jds-card">
        <JdsSkeleton width={200} height={24} style={{ marginBottom: 24 }} />
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="jds-detail-row">
            <JdsSkeleton width={120} height={14} />
            <JdsSkeleton width={160} height={14} />
          </div>
        ))}
      </div>
    </div>
  );
}

// Placeholder de formulário: título + campos (label + input de 40px).
export function JdsFormSkeleton({ fields = 6 }) {
  return (
    <div className="jds-scope" role="status" aria-label="Carregando">
      <div className="jds-card">
        <JdsSkeleton width={240} height={28} style={{ marginBottom: 32 }} />
        {Array.from({ length: fields }, (_, i) => (
          <div key={i} style={{ marginBottom: 20 }}>
            <JdsSkeleton width={140} height={12} style={{ marginBottom: 8 }} />
            <JdsSkeleton height={40} />
          </div>
        ))}
      </div>
    </div>
  );
}
